module.exports = __webpack_public_path__ + "static/img/icons.03b4091.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/trumbowyg/dist/ui/icons.svg
// module id = +XyB
// module chunks = 1